import { createFileRoute } from '@tanstack/react-router';
import { PreparerLoginPage } from '@/features/preparer/auth/PreparerLoginPage';

export const Route = createFileRoute('/preparer/login')({
  component: PreparerLoginPage,
});
